<template>
  <div class="container">
    <div class="card">
      <router-link :to="{ name: 'game-login' }">
        <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
      </router-link>
      <div class="block">
        <h2>Vous n’arrivez pas à vous connecter à la plateforme ?</h2>
        <p>
          Ci-dessous, sélectionnez la raison pour laquelle vous ne parvenez pas
          à vous connecter à la plateforme.
        </p>
      </div>
      <div class="btn-group">
        <router-link
          :to="{ name: 'game-forgot-password' }"
          class="btn outline secondary"
          >J'ai perdu mon mot de passe</router-link
        >
        <!-- Removed because we no longer have unicity of phone number
        <router-link
          :to="{ name: 'game-forgot-email' }"
          class="btn outline secondary"
          >Je ne me souviens plus de mon adresse e-mail</router-link
        > -->
      </div>
      <router-link
        class="btn primary icon icon-left"
        :to="{ name: 'game-home' }"
        ><i class="bi bi-arrow-left" /><span>Retour</span></router-link
      >
    </div>
  </div>
</template>
